import { jsxs as e, Fragment as t, jsx as n } from "react/jsx-runtime";
import { useState as r, Fragment as i } from "react";
import o from "@mui/icons-material/InfoOutlined";
import { Typography as c, Stack as s, Box as l, Input as a, Alert as p } from "@mui/joy";
import { ReadingFiles as d } from "./components/ReadingsFiles.js";
const g = ({ readings: g2, setReadings: h, setSelectedFiles: m, inputRefs: x, meterBitCapacity: f = 6, isReadingLowerThanPrevious: u = false }) => {
  const [y, j] = r(false), w = () => {
    j(true);
  }, b = () => {
    j(false);
  }, v = !y && u;
  return e(t, { children: [n(c, { level: "body-md", sx: { fontWeight: 600 }, children: "Внесіть покази" }), n(s, { direction: "row", justifyContent: "space-between", alignItems: "center", children: g2.map((t2, r2) => {
    const o2 = r2 === f - 1;
    return e(i, { children: [n(l, { sx: { display: "flex", alignItems: "center" }, children: n(a, { value: t2, onChange: (e2) => ((e3, t3) => {
      var _a;
      if (t3.length <= 1 && /^[0-9]*$/.test(t3)) {
        const n2 = [...g2];
        if (n2[e3] = t3, h(n2), "" !== t3) {
          const t4 = e3 + 1;
          t4 < g2.length && x.current[t4] && ((_a = x.current[t4]) == null ? void 0 : _a.focus());
        }
      }
    })(r2, e2.target.value), onKeyDown: (e2) => ((e3, t3) => {
      var _a;
      if ("Backspace" === t3.key && "" === g2[e3] && e3 > 0) {
        const t4 = e3 - 1;
        x.current[t4] && ((_a = x.current[t4]) == null ? void 0 : _a.focus());
      }
    })(r2, e2), onFocus: w, onBlur: b, sx: { width: "58px", height: "64px", textAlign: "center", fontSize: "24px", fontWeight: 400, border: "1px solid #E0E0E0", borderRadius: "16px", "--Input-placeholderOpacity": 0.4 }, slotProps: { input: { style: { textAlign: "center" }, ref: (e2) => {
      x.current[r2] = e2;
    } } }, placeholder: "0" }) }), o2 && n(l, { sx: { display: "flex", alignItems: "center" }, children: n(c, { sx: { mx: 1, fontSize: "18px", fontWeight: 600 }, children: "." }) })] }, r2);
  }) }), e(s, { flexDirection: "row", gap: 0.5, children: [n(o, { style: { width: "16px", height: "16px", color: "#616778" } }), n(c, { textColor: "neutral.500", sx: { fontSize: "12px" }, children: "Вкажіть всі цифри в тому порядку, як зображено на Вашому лічильнику" })] }), v && n(p, { color: "danger", variant: "soft", startDecorator: n(o, {}), children: "Внесені покази менші за попередньо передані. Будь ласка, прикріпіть файл або фото підтвердження" }), n(d, { onChange: m, accept: { "image/png": [".png"], "image/jpeg": [".jpg", ".jpeg"] }, acceptLabel: "PNG or JPG (max. 10MB)", title: "Файл або фото підтвердження" })] });
};
export {
  d as ReadingFiles,
  g as ReadingsInputSection
};
//# sourceMappingURL=index.js.map
